import React, { useMemo } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { DoneAll } from '@material-ui/icons'
import BottomButton from 'Components/BottomButton'
import { Icon } from 'Components/Icon'
import { useTransactions } from 'Stores/Transactions/useTransactions'
import { useTranslation } from 'react-i18next'

import './WithdrawCreditsSuccessful.scss'

const WithdrawCreditsSuccessful: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const { txHash } = useParams<{
    txHash: string
  }>()
  const { getExpectedTransactionByHash, getExplorerLink } = useTransactions()

  const expectedOutput = useMemo(() => {
    if (txHash) {
      return getExpectedTransactionByHash(txHash)
    }
    return undefined
  }, [txHash, getExpectedTransactionByHash])

  return (
    <div className="WithdrawCreditsSuccessful">
      <h1>{t('icon-pool-join.withdraw-credits-success')}</h1>
      <span className="WithdrawCreditsSuccessful__icon">
        <DoneAll />
      </span>

      {expectedOutput && (
        <>
          <div className="WithdrawCreditsSuccessful__summary">
            {expectedOutput.movements.withdrawn!.map((withdraw, i) => (
              <div key={i} className="summary-detail">
                <span className="summary-detail__logo">
                  <Icon icon={withdraw.name} />
                </span>
                <span className="summary-detail__reward">
                  <span className="summary-detail__reward__flow">
                    {t('remove-pool-successful.received')}
                  </span>
                  <h2>
                    {withdraw.value} {withdraw.name}
                  </h2>
                </span>
              </div>
            ))}
          </div>
          <div className="WithdrawCreditsSuccessful__blockchain-explorer">
            <a
              href={getExplorerLink(txHash)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {txHash}
            </a>
          </div>
        </>
      )}

      <div className="Wrapper-Bottom-Button">
        <BottomButton label={t('back')} onClick={() => history.goBack()} />
      </div>
    </div>
  )
}

export { WithdrawCreditsSuccessful }
